import { auth, app, FacebookAuthProvider } from './firebase'

const authProvider = new FacebookAuthProvider()
authProvider.setCustomParameters({
  prompt: 'select_account'
})

export const doSignIn = (): Promise<firebase.auth.UserCredential> => app.auth().signInWithPopup(authProvider)
export const doSignOut = (): Promise<void> => auth.signOut()
